import { render, staticRenderFns } from "./X-chantier-commandes.vue?vue&type=template&id=638ab434&scoped=true"
import script from "./X-chantier-commandes.vue?vue&type=script&lang=js"
export * from "./X-chantier-commandes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ab434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638ab434')) {
      api.createRecord('638ab434', component.options)
    } else {
      api.reload('638ab434', component.options)
    }
    module.hot.accept("./X-chantier-commandes.vue?vue&type=template&id=638ab434&scoped=true", function () {
      api.rerender('638ab434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/commandes/X-chantier-commandes.vue"
export default component.exports